import { Api } from '../axiosApi';
import { comOffline } from '../../../offline/servico';
import { kvGet, kvSet } from '../../../offline/db';

// 'comissao' não é um módulo do menu principal (não existe grupo "/comissao" no drawer) —
// é um sub-flag de Vendas que só controla as telas "Minhas Vendas" e "Vendas da Equipe"
// (ver MODULO_DA_ROTA e o campo `modulo` nos itens do menu, em routes/index.tsx).
export type TModuloEmpresa = 'vendas' | 'cadastros' | 'estoque' | 'financeiro' | 'fiscal' | 'servicos' | 'comissao';

export type IModulosEmpresa = Record<TModuloEmpresa, boolean>;

export const TODOS_MODULOS: IModulosEmpresa = {
  vendas: true,
  cadastros: true,
  estoque: true,
  financeiro: true,
  fiscal: true,
  servicos: true,
  comissao: true,
};

// Módulos contratados pela empresa do usuário logado — marcados no painel de
// controle (frontcontrole > Empresas > Módulos contratados).
const getModulosOnline = async (): Promise<IModulosEmpresa | Error> => {
  try {
    const { data } = await Api.get('/empresa/modulos');
    if (data) return { ...TODOS_MODULOS, ...data };
    return new Error('Erro ao consultar os módulos da empresa.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar os módulos da empresa.');
  }
};

// Módulos liberados pra empresa — guardados pra o menu continuar igual offline.
const getModulos = (): Promise<IModulosEmpresa | Error> =>
  comOffline(
    getModulosOnline,
    async () => (await kvGet<IModulosEmpresa>('modulosEmpresa')) ?? new Error('Módulos indisponíveis offline.'),
    (modulos) => kvSet('modulosEmpresa', modulos),
  );

export const ModulosEmpresaService = {
  getModulos,
};
